export const USER_SESSION_DURATION = 60 * 60 * 2; // 2 hours
export const CACHE_DURATION = 1000 * 60 * 60 * 24; // a day
